import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WeeklyActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WeeklyActivityResponseDataSchema>>

const getCampaignsActivityQueryKey = (campaignIds?: string[]) => [
  "campaigns",
  campaignIds,
  "activity",
]

export const campaignsActivityQuery = (campaignIds?: string[]) => {
  return queryOptions({
    queryKey: getCampaignsActivityQueryKey(campaignIds),
    queryFn: async () => {
      if (!campaignIds?.length) return null

      const response = await axios.get<Response>(`/campaigns/activity`, {
        params: { campaignIds },
      })
      return response.data.data
    },
    staleTime: 1000 * 60 * 2,
  })
}
